import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  updateFacetValues,
  isSelectedFacetValue,
  getAvailableFacetNameAttributesList,
  getSelectedFacetNameAttributes,
} from 'selectors/algolia2/facets'
import { getHrefFunction } from './helper'
import { SelectedFacets } from 'types/SearchProvider'
import { getAllSelectedFacets } from 'selectors/facets'

const mapStateToProps = createStructuredSelector({
  allSelectedFacets: getAllSelectedFacets,
  getHref: getHrefFunction,
  updateFacetValues: (state) => {
    // Availability to Add/Remove facet from a LIST
    return (facetName: string, facetValue: string) => {
      return updateFacetValues(facetName, facetValue)(state)
    }
  },
  getIsSelected: (state) => {
    return (facetName: string, attributeName: string) => {
      return isSelectedFacetValue({ facetName, attributeName })(state)
    }
  },
  getFacetNameAttributesList: (state) => (facetName) =>
    getAvailableFacetNameAttributesList(facetName)(state),
  getSelectedFacetAttributes: (state) => (facetName) =>
    getSelectedFacetNameAttributes(facetName)(state),
})

export type FacetsConnectorProps = {
  allSelectedFacets: ReadonlyArray<SelectedFacets>
  getHref: (filterParam: Record<string, any>) => string
  updateFacetValues: (facetName: string, facetAttribute: string) => void
  getIsSelected: (facetName: string, attributeName: string) => boolean
  getFacetNameAttributesList: (facetName: string) => ReadonlyArray<string>
  getSelectedFacetAttributes: (facetName: string) => ReadonlyArray<string>
}

export default connect(mapStateToProps)
